import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { fmtDate } from "./api";

const rs = (n) => "Rs. " + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 });

export function exportPdf({ site, branchName, start, end, data, branchMap }) {
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text(`Site: ${site.name}`, 14, 16);
  doc.setFontSize(10);
  doc.text(`Branch: ${branchName}`, 14, 23);
  const range = start || end ? `${start ? fmtDate(start) : "Beginning"} to ${end ? fmtDate(end) : "Today"}` : "All dates";
  doc.text(`Period: ${range}`, 14, 29);
  autoTable(doc, {
    startY: 35,
    head: [["#", "Date", "Branch", "Description", "Mode", "Deposit", "Withdraw"]],
    body: data.entries.map((e, i) => [
      i + 1,
      fmtDate(e.date),
      branchMap[e.branch_id] || "-",
      e.description || "-",
      e.mode,
      e.type === "deposit" ? rs(e.amount) : "",
      e.type === "withdraw" ? rs(e.amount) : "",
    ]),
    foot: [["", "", "", "", "Total", rs(data.total_deposit), rs(data.total_withdraw)],
           ["", "", "", "", "Net", rs(data.balance), ""]],
    headStyles: { fillColor: [15, 23, 42] },
    footStyles: { fillColor: [241, 245, 249], textColor: [15, 23, 42] },
    styles: { fontSize: 9 },
    columnStyles: { 5: { halign: "right" }, 6: { halign: "right" } },
  });
  doc.save(`${site.name.replace(/\s+/g, "_")}_entries.pdf`);
}

export function exportOverviewPdf({ data, start, end }) {
  const doc = new jsPDF();
  doc.setFontSize(16);
  doc.text("Dashboard Summary", 14, 16);
  doc.setFontSize(10);
  const range = start || end ? `${start ? fmtDate(start) : "Beginning"} to ${end ? fmtDate(end) : "Today"}` : "All dates";
  doc.text(`Period: ${range}`, 14, 23);
  doc.text(`Generated: ${new Date().toLocaleDateString("en-IN")}`, 14, 29);
  const style = { headStyles: { fillColor: [15, 23, 42] }, footStyles: { fillColor: [241, 245, 249], textColor: [15, 23, 42] }, styles: { fontSize: 9 } };
  doc.setFontSize(12);
  doc.text("Book-wise Summary", 14, 39);
  autoTable(doc, {
    startY: 42, ...style,
    head: [["#", "Book / Site", "Branches", "Entries", "Deposit", "Withdraw", "Net"]],
    body: data.sites.map((s, i) => [i + 1, s.name, s.branch_count, s.entry_count, rs(s.total_deposit), rs(s.total_withdraw), rs(s.balance)]),
    foot: [["", "Total", "", "", rs(data.total_deposit), rs(data.total_withdraw), rs(data.balance)]],
    columnStyles: { 4: { halign: "right" }, 5: { halign: "right" }, 6: { halign: "right" } },
  });
  const y = doc.lastAutoTable.finalY + 12;
  doc.text("Date-wise Summary", 14, y);
  autoTable(doc, {
    startY: y + 3, ...style,
    head: [["Date", "Entries", "Deposit", "Withdraw", "Net"]],
    body: data.days.map((d) => [fmtDate(d.date), d.entry_count, rs(d.deposit), rs(d.withdraw), rs(d.net)]),
    columnStyles: { 2: { halign: "right" }, 3: { halign: "right" }, 4: { halign: "right" } },
  });
  doc.save("dashboard_summary.pdf");
}
